import {EvkSeccionConfigModel} from "./evk-seccion-config.model";
import {EvkOption} from "@evomatik/evk-common";

export class EvkExpedienteConfigModel {

    id: string;
    nombre: string;
    descripcion: string;
    usoGenerales: boolean;
    seccionConfig: EvkSeccionConfigModel[];
    actualizar: EvkOption[];
    /** URL for update steps transition */
    url: string;
}
